import { Link } from "react-router-dom";
import { ArrowRight, LayoutGrid } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { resolveImageUrl, optimizedImageUrl } from "@/lib/api";

export const CategoriesSection = ({ content }) => {
  const { categories } = useSite();
  if (!categories.length) return null;

  return (
    <section className="py-16 bg-muted border-y border-border" data-testid="categories-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {content.eyebrow && (
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-primary mb-2">{content.eyebrow}</p>
        )}
        <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-foreground mb-8">
          {content.heading}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/inventory?category=${c.slug}`}
              className="group relative aspect-[4/3] overflow-hidden rounded-md border border-border hover:border-primary/60 transition-colors"
              data-testid={`category-card-${c.slug}`}
            >
              {c.image ? (
                <img src={optimizedImageUrl(resolveImageUrl(c.image), 900)} alt={`${c.title} category`} className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300" loading="lazy" />
              ) : (
                <div className="absolute inset-0 bg-secondary flex items-center justify-center">
                  <LayoutGrid className="h-10 w-10 text-muted-foreground" />
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="font-display text-lg font-bold uppercase text-white mb-1">{c.title}</h3>
                {c.description && <p className="text-sm text-zinc-300 mb-2 line-clamp-2">{c.description}</p>}
                <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-white">
                  Shop Now <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
